// chakra imports
import {
  Box,
  Button,
  Flex,
  Link,
  Stack,
  Text,
  useColorModeValue,
} from "@chakra-ui/react";
import IconBox from "components/Icons/IconBox";
import { Separator } from "components/Separator/Separator";
import { SidebarHelp } from "components/Sidebar/SidebarHelp";
import React from "react";
import { NavLink, useLocation } from "react-router-dom";

// this function creates the links and collapses that appear in the sidebar (left menu)
const SidebarContent = ({ logoText, routes }) => {
  let location = useLocation();
  const [state, setState] = React.useState({});

  const activeRoute = (routeName) => {
    return location.pathname === routeName ? "active" : "";
  };

  const createLinks = (routes) => {
    const activeBg = useColorModeValue("white", "gray.700");
    const inactiveBg = useColorModeValue("white", "gray.700");
    const activeColor = useColorModeValue("#071D54", "white");
    const inactiveColor = useColorModeValue("white", "gray.400");

    return routes.map((prop, key) => {
      if (prop.redirect) {
        return null;
      }
      if (prop.category) {
        return (
          <div key={prop.name}>
            <Text
              color={activeColor}
              fontWeight="bold"
              mb={{ xl: "12px" }}
              mx="auto"
              ps={{ sm: "10px", xl: "16px" }}
              py="12px"
            >
              {document.documentElement.dir === "rtl"
                ? prop.rtlName
                : prop.name}
            </Text>
            {createLinks(prop.views)}
          </div>
        );
      }
      if (prop.visible === false) {
        return null; // Skip hidden routes
      }
      const isActive = activeRoute(prop.layout + prop.path) === "active";

      return (
        <NavLink to={prop.layout + prop.path} key={prop.name}>
          <Button
            boxSize="initial"
            justifyContent="flex-start"
            alignItems="center"
            bg={isActive ? activeBg : "transparent"}
            mb={{ xl: "12px" }}
            mx={{ xl: "auto" }}
            py="12px"
            ps={{ sm: "10px", xl: "16px" }}
            borderRadius="15px"
            w="100%"
            _hover={isActive ? {} : { bg: "#1E3A8A", color: "white" }} // Apply hover only if not active
            _active={{
              bg: "inherit",
              transform: "none",
              borderColor: "transparent",
            }}
            _focus={{ boxShadow: "none" }}
          >
            <Flex>
              {typeof prop.icon === "string" ? (
                <Icon color="inherit">{prop.icon}</Icon>
              ) : (
                <IconBox
                  color={isActive ? "#071D54" : "white"}
                  h="30px"
                  w="30px"
                  me="12px"
                  _hover={!isActive ? { color: "white" } : {}} // Apply hover to icon only if not active
                >
                  {prop.icon}
                </IconBox>
              )}
              <Text
                color={isActive ? activeColor : inactiveColor}
                my="auto"
                fontSize="sm"
                _hover={!isActive ? { color: "white" } : {}} // Apply hover to text only if not active
              >
                {document.documentElement.dir === "rtl"
                  ? prop.rtlName
                  : prop.name}
              </Text>
            </Flex>
          </Button>
        </NavLink>
      );
    });
  };

  const links = <>{createLinks(routes)}</>;

  return (
    <>
      <Box pt={"25px"} mb="12px">
        <Link
          href={`${process.env.PUBLIC_URL}/#/`}
          target="_blank"
          display="flex"
          lineHeight="100%"
          mb="30px"
          fontWeight="bold"
          justifyContent="center"
          alignItems="center"
          fontSize="15px"
        >
          <Text fontSize="sm" mt="3px">
            {logoText}
          </Text>
        </Link>
        <Separator />
      </Box>
      <Stack direction="column" mb="40px">
        <Box>{links}</Box>
      </Stack>
      <Box mt="auto" mb="20px" />
    </>
  );
};

export default SidebarContent;
